
export interface IOrderLineItem {
    line_id: number;
    order_id: number;
    product_id: number;
    line_quantity: number;
    line_price: number;
    line_amount: number;
    line_order: number;
    line_description: string;
    
    created_by: number;
    created_at:number;
    updated_at:number;
  }

  export class  OrderLineItem implements IOrderLineItem {
    line_id!: number;
    order_id!: number;
    product_id!: number;
    line_quantity = 1;
    line_price!: number;
    line_amount = 0;
    line_order!: number;
    line_description!: string;
    
    created_by!: number;
    created_at!: number;
    updated_at!: number;
  }
  